import { render, staticRenderFns } from "./OptionsPage.vue?vue&type=template&id=3434d80b&"
import script from "./OptionsPage.vue?vue&type=script&lang=js&"
export * from "./OptionsPage.vue?vue&type=script&lang=js&"
import style0 from "../styles/options.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports